import { render } from "./customizeTable.vue?vue&type=template&id=410964a2&scoped=true"
import script from "./customizeTable.vue?vue&type=script&lang=js"
export * from "./customizeTable.vue?vue&type=script&lang=js"

import "./customizeTable.vue?vue&type=style&index=0&id=410964a2&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-410964a2"]])

export default __exports__